const channelType = {
	amazon: 'Amazon',
	overstock: 'Overstock',
	walmart: 'Walmart',
	wooCommerce: 'WooCommerce',
	costco: 'Costco',
	buybuyBaby: 'Buy Buy Baby',
	mattressFirm: 'Mattress Firm',
	homeDepot: 'Home Depot',
	wayfair: 'Wayfair',
	overstockCA: 'Overstock CA',
	logicBroker: 'LogicBroker',
	mirakl: 'Mirakl',
	shopify: 'Shopify',
	amazonVendor: 'Amazon Vendor',
	sellerCloud: 'Seller Cloud',
	manualOrders: 'Manual Orders',
};

export { channelType };



// WEBPACK FOOTER //
// ./src/common/constants/channelTypeConstants.js